/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_REGEX_REGION](state, payload) {
    state.regexRegion = payload;
  },
  [types.CHANGE_VIEW](state, payload) {
    state.activeView = payload;
  },
  [types.NEXT_STEP](state) {
    state.currentStep = state.currentStep + 1;
  },
  [types.BACK_STEP](state) {
    state.currentStep = state.currentStep - 1;
  },
  [types.RESET_STEP](state) {
    state.currentStep = 0;
  },
  [types.LAST_STEP](state) {
    state.currentStep = this.getters["personalization/getItemsData"].length;
  },
  [types.DELETE_DATA](state) {
    state.recipeData.pop();
  },
  [types.RESET_DATA](state) {
    state.recipeData = [];
  },
  [types.RESTORE_DATA](state,payload) {
    state.recipeData = payload;
  },
  [types.SAVE_DATA](state, { text, index = null, data = false }) {
    index = index !== null ? index : state.currentStep;
    const personalization = this.getters["personalization/getItemsData"];
    const indexPersonalization = state.recipeData[index]
      ? personalization.indexOf(
          personalization.find(
            e => e.location === state.recipeData[index].location
          )
        )
      : index;
    const {
      clone_dimensions,
      font_size,
      fonts,
      font_options,
      view,
      location,
      positioning
    } = personalization[indexPersonalization];
    const dataModel = data || {
      clone_dimensions,
      font_options,
      location,
      text,
      color: "black",
      factoryFontSize: font_size[text.length].factory_font_size,
      font: fonts[0],
      fontSize: font_size[text.length].display_font_size,
      hex: "#000000",
      image_views: {
        view,
        size: "square"
      },
      textAlign: positioning.textAlign
    };
    if (state.recipeData[index]) {
      state.recipeData[index] = dataModel;
    } else {
      state.recipeData.push(dataModel);
    }
  },
  [types.SAVE_USER_DATA](state) {
    if(!state.savedRecipeData) {
      state.savedRecipeData = [ ...state.recipeData ];
    }
  },
  [types.SET_FONT_SIZE](state) {
    if (state.recipeData.length > 1) {
      const text1 = state.recipeData[0] ? state.recipeData[0].text : "";
      const text2 = state.recipeData[1] ? state.recipeData[1].text : "";

      if (text1.length !== text2.length) {
        let indexBase = 0;
        let indexReplace = 1;
        if (text1.length < text2.length) {
          indexBase = 1;
          indexReplace = 0;
        }
        if (state.recipeData[indexReplace] && state.recipeData[indexBase]) {
          state.recipeData[indexReplace].factoryFontSize =
            state.recipeData[indexBase].factoryFontSize;
          state.recipeData[indexReplace].fontSize =
            state.recipeData[indexBase].fontSize;
        }
      }
    }
  },
  [types.CHANGE_COLOR](state, color) {
    for (let item of state.recipeData) {
      item.color = color.name;
      item.hex = color.hex;
    }
  },
  [types.ADD_PERSONALIZATION_COMPONENT](state, componentName) {
    if (!componentName || componentName === "undefined") return;
    const tempRecipe = this.getters["ugc/tempData/getRecipe"];
    const recipe = Object.keys(tempRecipe).length === 0 ? this.state.recipe.recipe_v2 : tempRecipe;
    if(Object.keys(state.recipeData).length > 0) {
      const { components = {} } = recipe;
      if (!components[componentName]) components[componentName] = {};

      components[componentName].personalization = [...state.recipeData];

      let tmpRecipe = {
        ...recipe,
        components
      };

      this.commit("ugc/tempData/SET_RECIPE", tmpRecipe);
    }
  },
  [types.SET_CHANGE_STYLE_FLOW](state, payload) {
    state.isChangeStyleFlow = payload;
  },
  [types.SET_PERSONALIZATION_POSITIONING](state, payload) {
    state.personalizationPositioning = JSON.parse(JSON.stringify(payload));
  }
};
export default mutations;
